<script setup>
import FAQCell from '@/pages/faq/components/FAQCell.vue';
import FAQGroup from '@/components/common/FAQGroup.vue';

import { CLAIM_FAQ_ITEMS } from '@/constants/faq';

const items = [...CLAIM_FAQ_ITEMS];

const props = defineProps({});
</script>

<template>
  <FAQGroup title="UFOs" bgVariant="blue2">
    <template #graphic>
      <img src="@/images/ufo-art-03_small.webp" />
    </template>
    <FAQCell
      v-for="({ title, subcontent }, index) in items"
      :key="index"
      :title="title"
      :subcontent="subcontent"
    />
  </FAQGroup>
</template>

<style module="s" lang="scss"></style>
